import { createGlobalStyle } from 'styled-components';

import colors from './styles/colors';
import typography from './styles/typography';
import './css/artifakt.css';

export default createGlobalStyle`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  html,
  body {
    height: 100%;
    margin: 0;
    padding: 0;
    font-family: ${typography.bodyMedium.fontFamily};
    font-weight: ${typography.bodyMedium.fontWeight};
    font-size: ${typography.bodyMedium.fontSize};
    line-height: ${typography.bodyMedium.lineHeight};
    color: ${colors.charcoal900};
  }

  button, input, optgroup, select, textarea {
    font-family: ${typography.bodyMedium.fontFamily};
    margin: 0;
  }

  input[type=text] {
    direction: auto
  }

  a {
    color: ${colors.adskBlue700};
  }
`;
